export default function CloseOnLogout() {
    const handleLogout = () => {
        // Clear client-side storage
        localStorage.clear();
        setTimeout(() => window.close(), 200);
    };

    // You can expose this function if you want to call it manually
    // For example: add a logout button that calls handleLogout()

    return null;
}